import React from "react";
import { Link } from "react-router-dom";
import CDMO_Image from "../../images/CDMO_Image.png";

export default function PipelineRedesign() {
  const services = [
    {
      title: "Pre-Formulation Services",
      icon: (
        // Beaker / Flask Icon
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
      desc: "DelNova is a fully integrated biopharmaceutical company with capabilities to develop and manufacture small and large molecules. We support our partners with Preformulation services, as it is the backbone of any robust formulation development project.",
      link: "/PreFormulServices",
    },
    {
      title: "Formulation Development Services",
      icon: (
        // Molecule / Chemistry Icon
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      desc: "Built on patient-focused innovation and drug delivery platforms. Our formulation expertise, with a blend of young and experienced scientists, helps develop robust and scalable processes. Our PKPD team supports 'Right the First Time' formulations, while our IP team enables early and timely launches.",
      link: "/FormulDevelopServices",
    },
    {
      title: "Technical Services",
      icon: (
        // Support / Operations Gear Icon
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      desc: "We understand the Quality aspects of Formulation and Analytical Development. To assist budding scientists and entrepreneurs in setting up state-of-the-art facility processes, we offer specialized services at our 'ViRACS Innovation Centre', fully integrated with our Business Automation Platform.",
      link: "/TechnicalServices",
    },
    {
      title: "Analytical Services",
      icon: (
        // Chart / Analytics Icon
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      desc: "Analytical development is critical to a product's lifecycle. Our team is well versed with ICH guidelines and requirements to establish accurate, precise, robust, and reproducible methods for analysis. We provide analytical development and validation services to startups and drug developers.",
      link: "/AnalyticalServices",
    },
  ];

  return (
    <div className="bg-[#F7F9FA] min-h-screen text-slate-800">
      {/* 1. Pipeline Hero Section */}
      <section className="relative min-h-[40vh] flex items-center justify-center pt-32 pb-16 overflow-hidden bg-brand-blue-deep">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40 mix-blend-overlay"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1579165466541-71702b859ec1?q=80&w=1920&auto=format&fit=crop')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-brand-blue-deep via-brand-blue/90 to-brand-blue/30" />
        <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center text-white z-10">
          <div className="inline-flex items-center space-x-2 bg-brand-teal/20 border border-brand-teal/30 rounded-full px-4 py-1.5 mb-4">
            <span className="text-brand-teal-light font-semibold text-xs uppercase tracking-wider">
              Services & Capabilities
            </span>
          </div>
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight mb-4 leading-tight">
            Full Service CDMO Capabilities
          </h1>
          <p className="max-w-2xl mx-auto text-base md:text-lg text-slate-300 font-light leading-relaxed">
            DelNova provides flexible services for contract development and manufacturing based on Quality in Design principles.
          </p>
        </div>
      </section>

      {/* 2. CDMO Overview Section */}
      <section className="py-20 max-w-7xl mx-auto px-6 md:px-12" id="cdmo">
        {/* Title Block */}
        <div className="max-w-3xl mb-12">
          <div className="inline-block text-xs font-semibold text-brand-teal uppercase tracking-widest bg-brand-teal/10 px-3 py-1 rounded-full mb-4">
            Core Capabilities
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-blue tracking-tight leading-tight">
            We are - A Full Service CDMO with End-to-End Capabilities.
          </h2>
        </div>

        {/* Text Details Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          {/* Main Description */}
          <div className="lg:col-span-7 space-y-6 text-slate-600 leading-relaxed text-base md:text-lg font-light">
            <p>
              DelNova provides services for contract development and manufacturing based on the{" "}
              <span className="font-semibold text-brand-blue">Quality in Design</span> principle. We support Generic and Innovator companies to develop stable and bioequivalent formulations with robust processes.
            </p>
            <p>
              We support our partners with either patent non-infringing formulations and processes thereof, or innovative formulation approaches. We assist our partners with clinical trial materials (First In Human Dose), product development, analytical method development and validation, commercial manufacturing, and stabilization of products with innovative packaging solutions.
            </p>
          </div>

          {/* Automation Callout Card */}
          <div className="lg:col-span-5 bg-gradient-to-br from-brand-blue/5 to-brand-teal/5 border border-slate-200/60 rounded-2xl p-6 shadow-sm flex flex-col justify-between relative overflow-hidden group hover:border-brand-teal/30 transition-all duration-300">
            <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-brand-teal/5 to-transparent rounded-tr-2xl" />
            <div>
              <div className="w-10 h-10 rounded-lg bg-brand-teal/10 flex items-center justify-center text-brand-teal mb-4">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
              <h4 className="text-base font-bold text-brand-blue mb-2">Integrated Business Automation</h4>
              <p className="text-slate-600 text-sm font-light leading-relaxed">
                Our services are integrated with a <strong className="font-semibold text-slate-800">Business Automation Platform (BAP)</strong>, aiming environment friendly and sustainability at core. Our BAP system, developed by the <a href="https://www.glogic.co.in" target="_blank" rel="noopener noreferrer" className="text-brand-blue font-semibold hover:underline">GLogic</a> Team, helps us to monitor real-time utilization of equipment and instruments, beside project management and financial diligence. This helps us optimize project costs and maintain transparent sharing of efforts.
              </p>
            </div>
          </div>
        </div>

        {/* Workflow Diagram Section */}
        <div className="relative">
          {/* Decorative glows */}
          <div className="absolute -inset-4 bg-gradient-to-r from-brand-blue/5 to-brand-teal/5 rounded-3xl blur-xl opacity-70" />
          <div className="relative bg-white border border-slate-100/80 rounded-2xl p-6 md:p-8 shadow-xl overflow-hidden group">
            <div className="border-b border-slate-100 pb-4 mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div>
                <h3 className="text-lg font-bold text-brand-blue">Integrated CDMO Workflow</h3>
                <p className="text-xs text-slate-500 font-light mt-0.5">End-to-end development, regulatory compliance, quality control, and technology transfer.</p>
              </div>
              <div className="flex items-center space-x-1.5 text-xs text-brand-teal font-semibold bg-brand-teal/10 px-2.5 py-1 rounded-full w-fit">
                <span className="w-1.5 h-1.5 rounded-full bg-brand-teal animate-pulse" />
                <span>Interactive Process Flow</span>
              </div>
            </div>
            <div className="flex justify-center bg-slate-50/50 rounded-xl p-4 md:p-6 border border-slate-100/60 overflow-x-auto">
              <img
                src={CDMO_Image}
                alt="CDMO End to End Capabilities Diagram"
                className="max-w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.01]"
                style={{ minWidth: "800px" }}
              />
            </div>
          </div>
        </div>
      </section>


      {/* 3. Services Grid Section */}
      <section className="py-20 bg-slate-50 border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <div className="inline-block text-xs font-semibold text-brand-teal uppercase tracking-widest bg-brand-teal/10 px-3 py-1 rounded-full mb-3">
              Partner Offerings
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue tracking-tight">
              Our Support to Partners for Timely Product Development
            </h2>
            <p className="text-slate-500 font-light mt-3">
              We provide full support across formulation development lifecycle to ensure successful, timely launches.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, idx) => (
              <div
                key={idx}
                className="bg-white border border-slate-100 hover:border-brand-teal/30 rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 flex flex-col justify-between"
              >
                <div>
                  {/* Icon wrapper */}
                  <div className="w-14 h-14 rounded-2xl bg-brand-teal-soft flex items-center justify-center text-brand-teal mb-6">
                    {service.icon}
                  </div>
                  {/* Title */}
                  <h3 className="text-xl font-bold text-brand-blue mb-4">
                    {service.title}
                  </h3>
                  {/* Description */}
                  <p className="text-slate-600 font-light text-sm md:text-base leading-relaxed">
                    {service.desc}
                  </p>
                </div>

                {/* Action Link */}
                <div>
                  <Link
                    to={service.link}
                    className="inline-flex items-center text-brand-teal hover:text-brand-teal-dark text-sm font-semibold mt-6 transition-colors group"
                  >
                    <span>Learn More</span>
                    <svg className="w-4 h-4 ml-1.5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
